import { Validators } from '@angular/forms';
import { PlannerDTOField } from '../interfaces/PlannerDTOField';
import { PlannerBaseDTO } from './PlannerBaseDTO';
import { FormBuilder } from '@angular/forms';
import { FlightScheduleDTO } from './FlightScheduleDTO';
import { ChannelPlanDTO } from './ChannelPlanDTO';
import { DemoSettingsDTO } from './DemoSettingDTO';
import { NationalLinearScheduleEnum } from '../enums/NationalLinearSchedule.enum';
// import { PlanObjective } from '../components/planner-edit/constants/PlanObjective.const';
import { flightScheduleDateValidator } from '../validators/customValidators';
import { PlanStatus } from '../components/planner-edit/constants/PlanStatus.const';

export class PlannerDTO extends PlannerBaseDTO {
    fields: PlannerDTOField[] = [
        { name: 'id', type: 'number' },
        { name: 'name', type: 'string', validators: [Validators.maxLength(225), Validators.required] },
        { name: 'advertiserId', type: 'number' },
        { name: 'advertiserName', type: 'string', validators: [Validators.required] },
        { name: 'marketId', type: 'number' },
        { name: 'marketName', type: 'string' },
        { name: 'accountId', type: 'number' },
        { name: 'accountName', type: 'string' },
        { name: 'labels', type: 'Array<string>' },
        {
            name: 'channels',
            type: 'Array<any>',
            defaultValue: ["DigitalVideo"],
            validators: [Validators.required]
        },
        {
            name: 'channelPlan',
            type: 'formGroup',
            arrayClass: ChannelPlanDTO,
            createInitialItem: true
        },
        // Not supported for V1 & V2
        // { name: 'objective', type: PlanObjective, defaultValue: PlanObjective.Reach.label, disabled: true },
        { name: 'linearScheduleId', type: 'number', defaultValue: NationalLinearScheduleEnum.uploadExistingSchedule },
        { name: 'linearScheduleName', type: 'string' },
        {
            name: 'flightSchedule',
            type: 'formGroup',
            arrayClass: FlightScheduleDTO,
            createInitialItem: true,
            groupValidator: flightScheduleDateValidator()
        },
        {
            name: 'demoSetting',
            type: 'formGroup',
            arrayClass: DemoSettingsDTO,
            createInitialItem: false
        },
        { name: 'createdDate', type: 'Date', includeInSaveDTO: false },
        { name: 'lastModifiedDate', type: 'Date', includeInSaveDTO: false },
        { name: 'status', type: 'string', defaultValue: PlanStatus.Draft.key },
        { name: 'version', type: 'number', includeInSaveDTO: false },
        { name: 'currency', type: 'string' },
        { name: 'marketTimeZone', type: 'string' },
        { name: 'activation', type: 'any' },
    ];

    constructor(fb?: FormBuilder) {
        super(fb);
        if (fb) {
            this.init();
        }
    }
}
